import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Contact: React.FC = () => {
  // Initialize the navigate function
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission behavior
    const form = e.target as HTMLFormElement;

    // Submit form data to Netlify
    const formData = new FormData(form);

    fetch("/", {
      method: "POST",
      body: formData,
    })
      .then(() => {
        // Redirect to the "Thank You" page
        navigate("/thank-you");
        // Optionally clear the form state
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("Error submitting the form:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  return (
    <div className="bg-background min-h-screen">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-gradientFrom to-gradientTo text-white py-20 text-center px-6">
        <h1 className="text-5xl font-serif mb-4">Contact Us</h1>
        <p className="text-lg font-sans max-w-2xl mx-auto">
          We're here to help. Get in touch with us for any inquiries or support.
        </p>
      </div>

      {/* Contact Form */}
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-lg mx-auto bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-3xl font-serif text-primary mb-6 text-center">
            Send us a Message
          </h2>
          <form
            name="contact"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
            className="space-y-4"
          >
            <input type="hidden" name="form-name" value="contact" />
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-sans text-primary mb-2"
              >
                Your Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 border border-primary/30 rounded-md"
                required
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-sans text-primary mb-2"
              >
                Your Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 border border-primary/30 rounded-md"
                required
              />
            </div>

            <div>
              <label
                htmlFor="message"
                className="block text-sm font-sans text-primary mb-2"
              >
                Your Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 border border-primary/30 rounded-md"
                rows={6}
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-primary text-white py-2 rounded-md hover:bg-primary/80 transition"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>

      {/* Additional Contact Information */}
      <div className="container mx-auto px-6 py-16 text-center text-secondary/80">
        <p className="text-lg font-sans">
          Or reach us directly at{" "}
          <a
            href="mailto:letstalk@openmetadata.net"
            className="font-bold hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            letstalk@openmetadata.net
          </a>
        </p>
      </div>
    </div>
  );
};

export default Contact;
